import { motion } from "framer-motion";
import { Wallet, Building2, ArrowUpRight } from "lucide-react";
import { Reveal, RevealLineOnScroll } from "./Reveal";
import { PRODUCTS, EASE } from "../data";

const ProductCard = ({ product, index }) => {
  const Icon = product.key === "consumer" ? Wallet : Building2;
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: EASE, delay: index * 0.12 }}
      className="rounded-2xl border bg-white p-8 md:p-12 flex flex-col"
      style={{ borderColor: "var(--border-light)" }}
      data-testid={`product-card-${product.key}`}
    >
      <div className="flex items-center justify-between mb-8">
        <div
          className="w-11 h-11 rounded-xl flex items-center justify-center"
          style={{ background: "rgba(59,61,242,0.08)" }}
        >
          <Icon size={20} style={{ color: "var(--primary-accent)" }} />
        </div>
        <span
          className="rounded-full border px-4 py-1.5 text-xs font-semibold"
          style={{
            borderColor: "var(--primary-accent)",
            color: "var(--primary-accent)",
          }}
        >
          {product.badge}
        </span>
      </div>

      <h3 className="font-display text-3xl md:text-4xl font-bold tracking-tight mb-4 text-black">
        {product.title}
      </h3>
      <p className="text-base md:text-lg mb-10 text-black/55">
        {product.blurb}
      </p>

      <ol className="mt-auto">
        {product.steps.map((step, i) => (
          <li
            key={i}
            className="group flex items-center gap-4 py-4 border-t"
            style={{ borderColor: "var(--border-light)" }}
            data-testid={`product-${product.key}-step-${i + 1}`}
          >
            <span
              className="font-mono-str text-xs w-6 shrink-0"
              style={{ color: "var(--primary-accent)" }}
            >
              0{i + 1}
            </span>
            <span className="text-sm md:text-base font-medium text-black/80">
              {step}
            </span>
            <ArrowUpRight
              size={16}
              className="ml-auto text-black/25 group-hover:text-[color:var(--primary-accent)] transition-colors duration-300"
            />
          </li>
        ))}
      </ol>
    </motion.div>
  );
};

export const Products = () => {
  return (
    <section
      id="products"
      data-testid="products-section"
      className="bg-[#f5f5f7] text-black pt-16 md:pt-20 pb-10 md:pb-12 border-t"
      style={{ borderColor: "var(--border-light)" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-12 md:mb-16">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[color:var(--primary-accent)] mb-6">
              Products
            </p>
          </Reveal>
          {/* <h2 className="font-display text-black text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.02] max-w-3xl">
            <RevealLineOnScroll>Choose how you</RevealLineOnScroll>
            <RevealLineOnScroll delay={0.08}>want to pay.</RevealLineOnScroll>
          </h2> */}
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {PRODUCTS.map((p, i) => (
            <ProductCard key={p.key} product={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
